module.exports = __webpack_public_path__ + "img/youtube.b4c4fd00.svg";